var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.53 88.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fa9400;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#272763;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.23,
    cy: 36.23,
    r: 36.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.4,19.9c-.13,0-.26-.05-.35-.15-.2-.2-.2-.51,0-.71,4.59-4.59,10.69-7.12,17.18-7.12s12.59,2.53,17.18,7.12c.2.2.2.51,0,.71s-.51.2-.71,0c-4.4-4.4-10.25-6.82-16.47-6.82s-12.07,2.42-16.48,6.82c-.1.1-.23.15-.35.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.58,88.52c-.71,0-1.42-.27-1.96-.81l-19.66-19.66c-.2-.2-.2-.51,0-.71s.51-.2.71,0l19.66,19.66c.69.69,1.81.69,2.51,0l4.17-4.17c.33-.33.52-.78.52-1.25s-.18-.92-.52-1.25l-24.17-24.17c-.92-.92-1.08-2.32-.39-3.42,3.53-5.58,5.15-12.03,4.7-18.67-1.05-15.44-13.48-27.81-28.92-28.77-8.91-.56-17.62,2.73-23.9,9.01s-9.57,15-9.01,23.9c.96,15.44,13.33,27.88,28.77,28.92,7.28.49,14.23-1.47,20.12-5.68.22-.16.54-.11.7.12.16.22.11.54-.12.7-6.09,4.34-13.28,6.37-20.77,5.86-15.94-1.08-28.71-13.92-29.7-29.86-.57-9.19,2.82-18.18,9.3-24.67S29.09,3.73,38.28,4.31c15.94,1,28.78,13.76,29.86,29.7.46,6.85-1.21,13.51-4.85,19.27-.44.69-.33,1.59.25,2.18l24.17,24.17c.52.52.81,1.22.81,1.96s-.29,1.44-.81,1.96l-4.17,4.17c-.54.54-1.25.81-1.96.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.23,44.31c-.28,0-.5-.22-.5-.5v-15.17c0-.28.22-.5.5-.5s.5.22.5.5v15.17c0,.28-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.81,36.73h-15.17c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h15.17c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.08,29.44c-.28,0-.5-.22-.5-.5v-6.34c0-.28.22-.5.5-.5s.5.22.5.5v6.34c0,.28-.22.5-.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.25,26.27h-6.34c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.34c.28,0,.5.22.5.5s-.22.5-.5.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCases);
export default __webpack_public_path__ + "static/media/cases.7de006365fc48ea84ac14c12601895cf.svg";
export { ForwardRef as ReactComponent };